import { TLocale } from "@src/i18n";
import { API_LANGUAGE_MAP } from "./languageHelper";

class URLHelper {
  getPLP(local: TLocale) {
    const data = {
      en: "/en/rent",
      ja: "/chintai",
      vi: "/vi/thue",
      pt: "/pt/apartamentos",
      zh: "/zh/zufang",
      my: "/my/einnghar",
      id: "/id/sewa",
      ne: "/ne/bhada",
    };
    return data[local];
  }
  // FIXME: Convert to a more common url prefix helper
  getPDPPrefix(local: TLocale) {
    return this.getPLP(local);
  }
  getParkingPrefix(local: TLocale) {
    const data = {
      ja: "/chushajo/chintai",
      en: "/en/parking/rent",
      pt: "/pt/estacionamento/alugar",
      vi: "/vi/bai-do-xe/thue",
      zh: "/zh/parking/zufang",
      ne: "/ne/parking/bhada",
      id: "/id/parkir/sewa",
      my: "/my/parking/thone",
    };
    return data[local];
  }
}

export function jsonApiPathWithLocale(
  type: "area" | "properties" | "trainline" | "parkingspots",
  locale: TLocale
): string {
  return `/api/${type}_${API_LANGUAGE_MAP[locale]}.json`;
}

const singleUrlHelper = new URLHelper();
export default singleUrlHelper;
